"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TrendingOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var TrendingOutlineSVG = function TrendingOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M29,9H20a1,1,0,0,0,0,2h6.41l-9.5,9.59-6.7-7.11a1,1,0,0,0-.7-.32,1.1,1.1,0,0,0-.72.28l-6.48,6.1a1,1,0,0,0,0,1.39A1,1,0,0,0,3.7,21l5.73-5.41,6.73,7.13a1,1,0,0,0,.72.32h0a1,1,0,0,0,.72-.3L28,12.21V19a1,1,0,0,0,2,0V10A1,1,0,0,0,29,9Z"
  }));
};
exports.TrendingOutlineSVG = TrendingOutlineSVG;
TrendingOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(TrendingOutlineSVG);
exports.default = _default;